<template>
    <div class="documentation-index">
      <Layout ref="layoutRef" :selectedOption="4" />
      <h2>Índice de Documentación</h2>
      <ul>
        <li v-for="(item, index) in documentationItems" :key="index">
          <a :href="item.url" target="_blank" rel="noopener noreferrer">
            <i class="fas fa-file-pdf"></i> {{ item.name }}
          </a>
        </li>
      </ul>
      <Footer/>
    </div>
  </template>
  
  <script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'

  export default {
    name: 'DocumentationIndex',
    components: {
        Layout, Footer
    },
    data() {
      return {
        documentationItems: [
          {
            name: 'Atenciones Médicas',
            url: 'path/to/AtencionesMedicas.pdf'
          },
          {
            name: 'Financiero-Tributario',
            url: 'path/to/FinancieroTributario.pdf'
          },
          {
            name: 'Dashboards',
            url: 'path/to/Dashboards.pdf'
          }
        ]
      };
    },
    mounted() {
        this.$refs.layoutRef.toggleProcesos()
        this.$refs.layoutRef.toggleReportes()
        this.$refs.layoutRef.toggleParametros()
        this.$refs.layoutRef.toggleAyuda()
    },
  };
  </script>
  
  <style scoped>
  .documentation-index {
    margin: 20px;
    padding: 15px;
    background: #f7f7f7;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .documentation-index h2 {
    color: #333;
    text-align: center;
    margin-bottom: 15px;
  }
  
  .documentation-index ul {
    list-style: none;
    padding: 0;
  }
  
  .documentation-index li {
    margin-bottom: 10px;
  }
  
  .documentation-index a {
    color: #0056b3;
    text-decoration: none;
    transition: color 0.3s;
  }
  
  .documentation-index a:hover {
    color: #00376b;
  }
  
  .documentation-index i {
    margin-right: 5px;
    color: #d00;
  }
  </style>  